// extracted by mini-css-extract-plugin
export default {"card":"CategoryCard_card__soNtr","imageContainer":"CategoryCard_imageContainer__8k+0Z","image":"CategoryCard_image__waJcv","name":"CategoryCard_name__bBaOU"};